/**
 * guide/step-preview 단계 미리보기 동기화 island.
 *
 * Mount: `<section data-mount="step-preview">` 안에
 *   - step 카드들 — `[data-step-order="N"][data-preview-url="..."]`
 *   - 폰 mock — `<img data-preview-img>` (+ optional `<div data-preview-caption>`)
 *
 * 흐름:
 *   - 단계 카드 mouseenter → `<img>.src` 교체 + 그 step 에 `data-step-active="true"`,
 *     나머지 step 은 false. 자동 진행 없음.
 *   - 터치/모바일 보강: click 도 동일 동작.
 *   - mount 시점에 첫 step (가능하면 order=1) 으로 초기화.
 *   - DOM only, fetch 0.
 */

type StepCard = HTMLElement & { dataset: DOMStringMap };

function getCards(root: HTMLElement): StepCard[] {
  return Array.from(root.querySelectorAll<HTMLElement>("[data-step-order][data-preview-url]"));
}

function setActive(cards: StepCard[], chosen: StepCard | null): void {
  for (const c of cards) {
    c.dataset.stepActive = c === chosen ? "true" : "false";
  }
}

function syncTo(
  card: StepCard,
  img: HTMLImageElement,
  caption: HTMLElement | null,
  cards: StepCard[],
): void {
  const url = card.dataset.previewUrl ?? "";
  if (url.length === 0) return;
  if (img.getAttribute("src") === url) return;
  img.setAttribute("src", url);
  if (caption) {
    const title = card.querySelector<HTMLElement>("[data-step-title]")?.textContent ?? "";
    caption.textContent = title;
  }
  setActive(cards, card);
}

export function mountStepPreview(root: HTMLElement): void {
  const img = root.querySelector<HTMLImageElement>("img[data-preview-img]");
  if (!img) return;
  const caption = root.querySelector<HTMLElement>("[data-preview-caption]");
  const cards = getCards(root);
  if (cards.length === 0) return;

  // 초기화 — 첫 step (order 가장 작은 것) 의 이미지로 set.
  const first = [...cards].sort(
    (a, b) => Number(a.dataset.stepOrder ?? "0") - Number(b.dataset.stepOrder ?? "0"),
  )[0];
  if (first) syncTo(first, img, caption, cards);

  for (const card of cards) {
    card.addEventListener("mouseenter", () => syncTo(card, img, caption, cards));
    card.addEventListener("click", (e) => {
      // 카드 안의 anchor·button 클릭은 통과 (이미지 swap만 추가 동작)
      void e;
      syncTo(card, img, caption, cards);
    });
  }
}
